<div class="dialog-panel">
  <div class="spinner-container p-absolute" *ngIf="loading">
    <mat-spinner class="primary" [diameter]="30"></mat-spinner>
  </div>
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <iframe id="preview-iframe"></iframe>
</div>
